import {
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../lib/firebase";
import type { SponsorCreate } from "@event-planner/shared";

/**
 * Shape the admin SponsorForm passes to `createSponsor`. Logo upload is
 * wired in edit mode via the SponsorForm Logo section (Issue #30).
 */
export type CreateSponsorInput = SponsorCreate;

export type UpdateSponsorInput = Partial<Omit<CreateSponsorInput, "eventId">>;

export async function createSponsor(
  input: CreateSponsorInput,
): Promise<string> {
  const docRef = await addDoc(collection(db, "sponsors"), {
    ...input,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
}

export async function updateSponsor(
  sponsorId: string,
  input: UpdateSponsorInput,
): Promise<void> {
  await updateDoc(doc(db, "sponsors", sponsorId), {
    ...input,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteSponsor(sponsorId: string): Promise<void> {
  await deleteDoc(doc(db, "sponsors", sponsorId));
}
